import React from 'react';
import Section from './Section';

function Education() {
  return (
    <Section title="Education">
      <p>
        University of Georgia, School of Computing, Athens, GA<br />
        Bachelor of Science, Computer Science<br />
        Emphasis, Software Design<br />
        December 2025
      </p>
    </Section>
  );
}

export default Education;